export default "__VITE_ASSET__d74b26c2__"